import React from 'react';
import Softphone from './Softphone';
import NewPhone from './NewPhone';

function App() {
  return (
    <div className="App">
      <Softphone />
      {/* <NewPhone /> */}
    </div>
  );
}

export default App;
